import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

const channels = [
  {
    title: 'Mailing list',
    body: 'Join the discussion list to ask questions, share images, and get help from experienced operators and the development team.',
  },
  {
    title: 'Issue tracker',
    body: 'Follow active bug reports and feature requests, or file your own. Transparency is part of the open-source promise.',
  },
  {
    title: 'Contribute test data',
    body: 'Have a radio that is not yet supported? Sharing memory images and test results is one of the most valuable ways to help.',
  },
]

export default function CommunityPage() {
  return (
    <ContentPage
      eyebrow="// community"
      title="Join the NewChirp community"
      description="NewChirp is built by operators, for operators. Whether you're asking your first question or helping add a new radio, there's a place for you."
    >
      <Prose>
        <Section title="Ways to connect">
          <div className="grid gap-4 sm:grid-cols-1">
            {channels.map((channel) => (
              <div key={channel.title} className="rounded-xl border border-border bg-card p-6">
                <h3 className="text-lg font-semibold text-foreground">{channel.title}</h3>
                <p className="mt-2 leading-relaxed text-muted-foreground">{channel.body}</p>
              </div>
            ))}
          </div>
        </Section>

        <Section title="A friendly place to learn">
          <p>
            Amateur radio has a long tradition of operators helping each other. The NewChirp
            community keeps that spirit alive — no question is too basic. If you are just getting
            started, the{' '}
            <Link href="/beginners-guide" className="text-primary underline underline-offset-4">
              Beginners Guide
            </Link>{' '}
            is a great first stop.
          </p>
        </Section>

        <Section title="Want to help build NewChirp?">
          <p>
            Developers, testers, and documentation writers are always welcome. Head to the{' '}
            <Link href="/developers" className="text-primary underline underline-offset-4">
              developers page
            </Link>{' '}
            to see how to get involved.
          </p>
        </Section>
      </Prose>
    </ContentPage>
  )
}
